import { ViewResolver } from '@Components/index';
import WrapperMobilePage from './mobile/WrapperMobilePage';
import WrapperDesktopPage from './desktop/WrapperDekstopPage';

const WrapperPage: React.FC = () => {
  return (
    <ViewResolver
      desktop={<WrapperDesktopPage />}
      mobile={<WrapperMobilePage />}
    />
  );
};

export default WrapperPage;
